import http from '@/services/http';
import { usersFilters } from '@/config';
import tableHelper from '@/services/tableHelper';

const laboratoriesFilter = {
  name: 'laboratories',
  label: 'laboratory',
  type: 'text',
  whereOperator: 'regexp',
};

const roleNames = {
  name: 'roleNames',
  label: 'role',
  type: 'text',
  whereOperator: 'regexp',
};

const users = {
  login(attributes) {
    return http.request({
      method: 'post',
      url: '/users/login',
      data: attributes,
    });
  },
  switchLab() {
    return http.request({
      method: 'post',
      url: '/users/refresh',
    });
  },
  getInfo() {
    return http.request({
      method: 'get',
      url: '/users/me',
    });
  },
  patchMe(data) {
    return http.request({
      method: 'patch',
      url: '/users/me',
      data,
    });
  },
  index(tableFilters, filterStatus, config = {}) {
    const { isEnabled, ...whereRoles } = filterStatus;
    const { laboratory, name } = whereRoles;
    let filters = {};

    const whereUsersFilters = [
      ...usersFilters,
      { ...laboratoriesFilter },
      { ...roleNames },
    ];

    const usedFilters = Object.assign(
      isEnabled !== undefined && { isEnabled },
      laboratory !== undefined && { laboratories: laboratory },
      name !== undefined && { roleNames: name }
    );

    filters = tableHelper.whereFilters(usedFilters, whereUsersFilters);

    const rolesFilters = tableHelper.whereFilters(whereRoles, usersFilters);
    return http.request({
      method: 'get',
      url: '/users',
      params: {
        filter: { ...tableFilters, where: filters },
        whereRoles: rolesFilters,
      },
      ...config,
    });
  },
  count(filterStatus, config = {}) {
    const where = tableHelper.whereFilters(filterStatus, usersFilters);
    return http.request({
      method: 'get',
      url: '/users/count',
      params: { where },
      ...config,
    });
  },
  show(id) {
    return http.request({
      method: 'get',
      url: `/users/${id}`,
    });
  },
  patch(id, data) {
    return http.request({
      method: 'patch',
      url: `/users/${id}`,
      data,
    });
  },
  bulkUpdate(ids, data) {
    return http.request({
      method: 'patch',
      url: '/users',
      params: { where: { id: { inq: ids } } },
      data,
    });
  },
  unlockUser(id) {
    return http.request({
      method: 'post',
      url: `/users/${id}/unlock`,
    });
  },
};

export default users;
